/**
 * Admin API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DynamicFormIntegrationValue } from './dynamic-form-integration-value';
import { DynamicFormPotentialAnswer } from './dynamic-form-potential-answer';
import { DynamicFormConstraintOption } from './dynamic-form-constraint-option';


export interface DynamicFormQuestion { 
    id: string;
    name?: string;
    sequence?: number;
    description?: string;
    lastUpdated?: string;
    groupId: string;
    patientPrompt?: string;
    placeHolder?: string;
    characterCount?: number;
    enabled?: boolean;
    elementType: DynamicFormQuestion.ElementTypeEnum;
    required?: boolean;
    width?: number;
    potentialAnswersWidth?: number;
    show?: boolean;
    selectedValue?: string;
    integrationValue?: Array<DynamicFormIntegrationValue>;
    /** @deprecated */
    constraintId?: string;
    constraintOptions?: Array<DynamicFormConstraintOption>;
    potentialAnswers?: Array<DynamicFormPotentialAnswer>;
}
export namespace DynamicFormQuestion {
    export const ElementTypeEnum = {
        Alpha: 'ALPHA',
        Checkbox: 'CHECKBOX',
        Date: 'DATE',
        Dropdown: 'DROPDOWN',
        Email: 'EMAIL',
        Image: 'IMAGE',
        Input: 'INPUT',
        MultiCheckbox: 'MULTI_CHECKBOX',
        Numeric: 'NUMERIC',
        Pdf: 'PDF',
        Phone: 'PHONE',
        Radio: 'RADIO',
        Text: 'TEXT',
        Title: 'TITLE',
        Upload: 'UPLOAD',
        Unknown: 'UNKNOWN'
    } as const;
    export type ElementTypeEnum = typeof ElementTypeEnum[keyof typeof ElementTypeEnum];
}


